module.exports = __webpack_public_path__ + "img/dev_et_drone_blanc.ec8bae90.png";